
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

const normalizeFilters = (filters = {}) => {
  return Object.entries(filters).reduce((params, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      params[key] = value;
    }

    return params;
  }, {});
};

export const fetchFeedback = createAsyncThunk(
  "feedback/fetchFeedback",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await apiCustom.get("/comment-showAll", {
        params: normalizeFilters(filters),
      });

      const result = response.data?.data || {};

      return {
        feedbacks: result.data || [],
        totalItems: result.totalItems || 0,
        totalPage: result.totalPage || 1,
        currentPage: result.currentPage || 1,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Đã xảy ra lỗi khi tải bình luận!"
      );
    }
  }
);

export const updateFeedback = createAsyncThunk(
  "feedback/updateFeedback",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/comment-approve/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedbacks",
  initialState: {
    feedbacks: [],
    totalItems: 0,
    totalPage: 1,
    currentPage: 1,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeedback.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.feedbacks = action.payload.feedbacks;
        state.totalItems = action.payload.totalItems;
        state.totalPage = action.payload.totalPage;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateFeedback.fulfilled, (state) => {
        state.status = "succeeded";
      });
  },
});

export default feedbackSlice.reducer;

